import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currIndex: 0,
  kirtanId: 0,
  shortcutIndex: null,
  searchFlag: false,
  selectedLine: 0,
  seq_id: 0,
  book_id: 0,
  database_id: 0,
};

export const KirtanIndexSlice = createSlice({
  name: "KirtanIndex",
  initialState,
  reducers: {
    setCurrKirtanIndex: (state, action) => {
      state.currIndex = action.payload;
    },
    setKirtanIndex: (state, action) => {
      state.kirtanId = action.payload;
    },
    setShortcutIndex: (state, action) => {
      state.shortcutIndex = action.payload;
    },
    setSelectedLine: (state, action) => {
      state.selectedLine = action.payload;
    },
    setSearchFlag: (state, action) => {
      state.searchFlag = action.payload;
    },
    setSeqId: (state, action) => {
      state.seq_id = action.payload;
    },
    setBookId: (state, action) => {
      state.book_id = action.payload;
    },
    setDatabaseId: (state, action) => {
      state.database_id = action.payload;
    }
  }
});

export const {
  setCurrKirtanIndex,
  setKirtanIndex,
  setShortcutIndex,
  setSelectedLine,
  setSearchFlag,
  setSeqId,
  setBookId,
  setDatabaseId
} = KirtanIndexSlice.actions;

export default KirtanIndexSlice.reducer;
